import {ApplicationInsights} from '@microsoft/applicationinsights-web'
import {ReactPlugin} from '@microsoft/applicationinsights-react-js'

export const startApplicationInsights = () => {
  if (APPLICATIONINSIGHTS_INSTRUMENTATIONKEY) {
    const reactPlugin = new ReactPlugin()
    const appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: APPLICATIONINSIGHTS_INSTRUMENTATIONKEY,
        extensions: [reactPlugin],
        enableAutoRouteTracking: true,
        disableCookiesUsage: true,
        extensionConfig: {
          ['AppInsightsCfgSyncPlugin']: {
            cfgUrl: '', // this will block fetching from default cdn
          },
        },
      },
    })
    return appInsights.loadAppInsights()
  }
  // eslint-disable-next-line no-console
  return console.warn('APPLICATIONINSIGHTS_INSTRUMENTATIONKEY not found. Starting without ApplicationInsights.')
}
